var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSharing = function SvgSharing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Telecounselling",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.1.9-Telecounsel-/-Queue----in-call---cam-off",
    transform: "translate(-776, -800)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(480, 784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chat",
    transform: "translate(280, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(16, 16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62499995,15.75 C2.62607649,16.7850877 3.46491229,17.6239235 4.49999996,17.625 L9.72968749,17.625 L9.57343749,18.875 L7.62499995,18.875 C7.27982201,18.875 6.99999998,19.1548221 6.99999998,19.5 C6.99999998,19.845178 7.27982201,20.125 7.62499995,20.125 L16.375,20.125 C16.720178,20.125 17,19.845178 17,19.5 C17,19.1548221 16.720178,18.875 16.375,18.875 L14.4265625,18.875 L14.2703125,17.625 L19.5,17.625 C20.5350877,17.6239235 21.3739235,16.7850877 21.375,15.75 L21.375,13.875 L2.62499995,13.875 L2.62499995,15.75 Z M12,15.125 C12.345178,15.125 12.625,15.404822 12.625,15.75 C12.625,16.095178 12.345178,16.375 12,16.375 C11.654822,16.375 11.375,16.095178 11.375,15.75 C11.375,15.404822 11.654822,15.125 12,15.125 Z M21.375,5.74999997 C21.3739235,4.7149123 20.5350877,3.87607649 19.5,3.87499996 L4.49999996,3.87499996 C3.46491229,3.87607649 2.62607649,4.7149123 2.62499995,5.74999997 L2.62499995,13.25 L21.375,13.25 L21.375,5.74999997 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    mask: "url(#mask-2)"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSharing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sharing.f59990f9.svg";
export { ForwardRef as ReactComponent };